<div class="container-fluid py-2" *ngIf="storeItem">
    <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="card " id="sd_storeitemdetail_card">
                <div class="card-body" id="sd_storeitemdetail_card_body">
                    <div *ngIf="serverError!=null" class="alert alert-danger" [innerHTML]="serverError">
                    </div>

                    <div class="row" id="newItemRequestHeading">
                        <span>{{ 'StoreItemDetail.newItemRequest' | translate }}</span>
                    </div>

                    <div class="row" style="padding-left: 2rem; padding-bottom: 1rem;">
                        <div id="storeitem_breadcrumbs" class="breadcrumb-font">
                            <span style="color: #0079EF; cursor: pointer;"
                                [routerLink]='["/store"]'>{{ 'StoreItemDetail.storeItem' | translate }}</span> >
                            <span> {{ 'StoreItemDetail.newItemRequest_co' | translate}} </span>
                            <span> {{ storeItemDetail.storeItemName }} </span>
                        </div>
                    </div>

                    <div class="row" id="storeitem_name_description_row">
                        <div class="col-lg-10 col-md-9 col-xl-10 col-sm-8 col-8">
                            <!--Store Item Name-->
                            <div id="sd_store_item_name" class="detail-title-font">
                                {{ storeItemDetail.storeItemName }}
                            </div>
                            <!--Store Item Description-->
                            <div>
                                <div id="store_item_description_input"
                                    [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(storeItemDetail.storeItemDescription)">
                                </div>
                            </div>
                        </div>
                        <!--Store Item Image-->
                        <div class="col-lg-2 col-md-3 col-xl-2 col-sm-4 col-4">
                            <img id="zsd_card_image" *ngIf="storeItemDetail.iconData"
                                [src]="_DomSanitizer.bypassSecurityTrustUrl('data:' + storeItemDetail.iconMime + ';base64, ' + storeItemDetail.iconData)">
                        </div>
                    </div>
                    <form (ngSubmit)="createRequest()" [formGroup]="storeItemDetailForm">


                        <!-- Request CC Field -->
                        <div *ngIf=showNotifyField class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                                    <label for="requestCC" id="sd_request_cc">{{'StoreItemDetail.CCField' | translate }}
                                    </label>
                                </div>
                                <div class="cc_input_field col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                                    <div>
                                        <div class="cc-area">
                                            <div class="cc-details" (click)="setFocusToCCField();">
                                                <div class="selected-user" *ngFor="let user of ccList;let i=index">
                                                    <span>{{getUserDisplayString(user)}}<span id="remove_icon"
                                                            class="icon-cancel-circle" (click)="removeFromCCList(i)"><em
                                                                class="fas fa-times-circle"></em></span></span>
                                                    <!-- <button class="btn btn-info btn-sm remove-user-btn" type="submit" (click)="removeFromCCList(i)">&times;</button> -->
                                                </div>
                                                <div>
                                                    <input [attr.id]="'input-user' + index" type="text"
                                                        class="form-control input-user" aria-describedby="ccField"
                                                        [formControl]="ccField" (keydown)="ccListKeyPressAction($event)"
                                                        autocomplete="off">
                                                    <div *ngIf="ccField?.value?.length > 1" class="searchList" id="storedetail-search-list" (scroll)="scrollEndForCustomerSearch()">
                                                        <span
                                                            *ngIf="usersLoading">{{'RequestDetail.loading' | translate}}</span>
                                                        <a [attr.id]="'user' + i" class="dropdown-item"
                                                            [ngClass]="{'active-element-in-list': i === currentCcUserIndex}"
                                                            (click)="addToCCList(user);"
                                                            *ngFor="let user of userSearchInfo.results; let i = index">{{getUserDisplayString(user)}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    </div>
                        </div>
                        <!-- Request CC Field End-->

                        <!--Request Description-->
                        <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <div class="row">
                                <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                                    <label for="requestDescription"
                                        id="sd_request_info">{{ 'StoreItemDetail.requestDescription' | translate }}
                                        <span id="mandatory_field">&#42;</span>
                                    </label>
                                </div>
                                <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12">
                                    <zsd-tinymce [parentForm]="storeItemDetailForm"
                                        [tinymceData]="storeItemDetail.requestDescription" [required]=true
                                        [requiredError]="'StoreItemDetail.descriptionRequired' | translate">
                                    </zsd-tinymce>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="storeItemDetail.showTargetDevice"
                            class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <div class="row pt-2">
                                <div class="col-md-2 col-lg-2 col-xl-2">
                                    <label for="targetDevice" id="sd_target_device_label">
                                        {{ 'StoreItemDetail.targetDevice' | translate }}
                                        <span id="mandatory_field">&#42;</span>
                                    </label>
                                </div>
                                <div class="col-md-3 col-lg-3 col-xl-3">
                                    <select class="form-control custom-select" id="targetDevice"
                                        formControlName="targetDevice" #c [(ngModel)]="targetDeviceId"
                                        (change)="setTargetItem(c.value)" [ngClass]="{'error-class': storeItemDetail.showTargetDevice && storeItemDetailForm.controls['targetDevice'].touched && 
                                    !checkTargetDevice()  } ">
                                        <option [value]="defaultTargetDevice" selected>
                                            {{ getTargetDeviceNoSelectionString() | translate }}</option>
                                        <option *ngFor="let opt of storeItemDetail.targetDevices" [value]="opt.itemId">
                                            {{ opt.itemName }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2 col-lg-2 col-xl-2">
                                </div>
                                <div class="col-md-3 col-lg-3 col-xl-3 validation-error-inline text-danger" *ngIf="(storeItemDetail.showTargetDevice) &&
                                storeItemDetailForm.controls['targetDevice'].touched && !checkTargetDevice()">
                                    {{ 'StoreItemDetail.targetDeviceValidationMessage' | translate }}
                                </div>
                            </div>
                        </div>


                        <!-- Custom Fields Component (storeItemDetailForm.controls['targetDevice'].touched &&  -->
                        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <!-- To check the Custom Fields in the UI uncomment this -->
                            <zsd-customfields [parentForm]="storeItemDetailForm"
                                [customFields]="storeItemDetail.customFields" [fromQuickCall]=false [id]="null">
                            </zsd-customfields>
                        </div>
                        <!-- Custom Fields Component (storeItemDetailForm.controls['targetDevice'].touched &&  -->
                        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <!-- To check the Dynamic form in the UI uncomment this -->
                            <zsd-formio #formio [parentForm]='storeItemDetailForm' 
                            [formSchema]='formSchema' [fromStoreItem]='true'></zsd-formio>
                        </div>

                        <!-- Additional Information -->
                        <div *ngIf=showAdditionalInfo class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <zsd-additionalinfo [parentForm]="storeItemDetailForm"></zsd-additionalinfo>
                        </div>


                        <!-- Contact Information-->
                        <div *ngIf=showAdditionalInfo class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <zsd-contactinfo [parentForm]="storeItemDetailForm"></zsd-contactinfo>
                        </div>


                        <!-- File Upload Component -->
                        <div class="form-group col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12 mt-3">
                            <div class="row">
                                <div class="col-lg-2 col-md-12 col-xl-2 col-sm-12 col-12">
                                    <label for="attachment">{{ 'StoreItemDetail.attachment' | translate }}
                                    </label>
                                </div>
                                <div class="col-lg-10 col-md-12 col-xl-10 col-sm-12 col-12" id="attachment_upload">
                                    <zsd-fileupload (isformValid)="isfileuploadformvalid($event)"
                                        (filesSelected)="selectedFilesList($event)"></zsd-fileupload>
                                </div>
                            </div>
                        </div>

                        <div style="margin-left:-20px; margin-right: -20px;" id="zsd_button_separation_line">
                        </div>

                        <!--Create & Cancel Button-->
                        <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
                            <div class="row">
                                <div class="col-lg-5 col-md-5 col-xl-5">&nbsp;</div>
                                <div class="col-lg-2 col-md-2 col-xl-2 col-sm-12 col-12" id="sd_store_item_spinner">
                                    <div *ngIf="loading" id="spinner" role="progressbar">
                                        <zsd-spinner></zsd-spinner>
                                    </div>
                                </div>
                                <div class="col-lg-5 col-md-5 col-xl-5 col-sm-12 col-12">
                                    <div class="form-group float-right">
                                        <button type="submit" class="btn zsd_button button-equal"
                                            id="zsd_cust_button_create" (click)="callFormioSubmitButton()">{{ 'StoreItemDetail.createButton' | translate }}</button>
                                        <button type="button" class="btn zsd_button button-equal"
                                            id="zsd_cust_button_cancel"
                                            (click)="cancelRequest()">{{ 'StoreItemDetail.cancelButton' | translate }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
</div>